module.exports = __webpack_public_path__ + "other-white.svg?faa24566d1414defc48aac09de821114";